import { useFlags } from 'launchdarkly-react-client-sdk'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { News } from '../../__legacy__/components/platform/dashboard/news'
import { useTreeState } from '../../__legacy__/stores/Root'
import { ArpTable } from '../arp-table'
import { TableRow } from '../arp-tablerow'
import { Actions, Page } from './primitives'

const TITLE = 'Welcome to Arpeggi Studio'
const SUBTITLE = 'Discover samples and loops to download or remix'

const ActionSection = () => {
  const flags = useFlags()
  const remixSamplePackIndex = flags['remixSamplePackIndex'] || 12
  return (
    <Actions.Root>
      <Actions.Card as={Link} to={'/sounds'}>
        <Actions.Icon as={Actions.Soundwave} />
        <Actions.Main>
          <Actions.Title>Browse Samples</Actions.Title>
          <Actions.Subtitle>Find unique one-shots and loops to create with</Actions.Subtitle>
        </Actions.Main>
      </Actions.Card>

      <Actions.Card as={Link} to={`/sample-packs/${remixSamplePackIndex}`}>
        <Actions.Icon as={Actions.Repeat} />
        <Actions.Main>
          <Actions.Title>Remix</Actions.Title>
          <Actions.Subtitle>
            Download your favorite stems and join a remix activation
          </Actions.Subtitle>
        </Actions.Main>
      </Actions.Card>

      <Actions.Card as={Link} to={'/studio'}>
        <Actions.Icon as={Actions.Create} />
        <Actions.Main>
          <Actions.Title>Create</Actions.Title>
          <Actions.Subtitle>Start creating instantly in our free in-browser DAW</Actions.Subtitle>
        </Actions.Main>
      </Actions.Card>
    </Actions.Root>
  )
}

const { Filters, Headers, DEFAULT_SONGS_FILTERS } = ArpTable

const SongTable: FC = observer(() => {
  const { globalPlayer } = useTreeState()
  const currentId = globalPlayer.arpMediaIndex
  return (
    <ArpTable.Root defaultFilters={DEFAULT_SONGS_FILTERS}>
      <Filters.Root>
        <Filters.Genre />
        <Filters.Key />
      </Filters.Root>
      <Headers.Root>
        <Headers.Title />
        <Headers.Tags />
        <Headers.DateMinted />
        <Headers.Plays />
        <Headers.Favorite />
        <Headers.Duration />
      </Headers.Root>
      <ArpTable.Table>
        {(media) => (
          <TableRow.Root media={media} key={media.id} active={currentId === media.id}>
            <TableRow.Main />
            <TableRow.Tags />
            <TableRow.DateMinted />
            <TableRow.Plays />
            <TableRow.Favorite />
            <TableRow.Duration />
            <TableRow.Actions />
          </TableRow.Root>
        )}
      </ArpTable.Table>
    </ArpTable.Root>
  )
})

export const Home: FC = () => {
  return (
    <Page.Root>
      <Page.Flare type="one" />
      <Page.Flare type="two" />
      <Page.Content>
        <Page.Title>{TITLE}</Page.Title>
        <Page.Subtitle>{SUBTITLE}</Page.Subtitle>
        <ActionSection />
        <Page.Title small>Recent News</Page.Title>
      </Page.Content>
      <News />
      <Page.Content>
        <Page.Title small>Recently Minted Remixes</Page.Title>
        <SongTable />
      </Page.Content>
    </Page.Root>
  )
}
